import { useCallback } from 'react'
import axios from 'axios'

const useReceitaWSClient = () => {
  const getInfoByCnpj = useCallback(async (cnpj) => axios.get(`/client/ReceitaWS/${cnpj}`, {
    timeout: 60000,
  }).then((res) => res?.data), [])

  return useCallback(() => ({
    getInfoByCnpj,
  }), [
    getInfoByCnpj,
  ])
}

export default useReceitaWSClient
